import { SidebarArticlesPreview } from '@components/sidebar-articles-preview'
import { Author } from '@services/api/authors'
import classNames from 'classnames'
import Link from 'next/link'
import Image from 'next/image'

import styles from './styles.module.scss'

interface AuthorCard extends Author {
  className?: string
}

export const AuthorCard = ({
  name,
  path,
  avatar,
  biography,
  articles,
  className
}: AuthorCard): JSX.Element => {
  return (
    <div className={classNames(styles.authorCard, className)}>
      <div className={styles.authorCardHeader}>
        <Link href={path} passHref>
          <div className={styles.authorCardContent}>
            {avatar ? (
              <div className={styles.authorCardAvatar}>
                <Image
                  src={avatar}
                  alt="Imagem Articulista"
                  height={96}
                  width={96}
                  loader={({ src }) => src}
                  loading="lazy"
                />
              </div>
            ) : (
              <div className={styles.authorCardAvatar}>
                <Image
                  src="/no-profile-avatar.svg"
                  alt="Imagem Articulista"
                  height={96}
                  width={96}
                  loading="lazy"
                />
              </div>
            )}
            <div className={styles.authorCardNames}>
              <h2>{name}</h2>
            </div>
          </div>
        </Link>
        <div className={styles.authorCardBiography}>
          <span>{biography}</span>
        </div>
      </div>
      <SidebarArticlesPreview
        articles={articles}
        header={{ left: { text: 'Últimos artigos' } }}
        className={styles.articlesContainer}
      />
    </div>
  )
}
